<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-26 11:46:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-27 10:59:30
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/src/case-7/index.vue
-->
<template>
  <el-container class="case-7-view">
    <!-- <Case7Header ref="Case7HeaderRef" @inquire="inquireHandel">
    </Case7Header> -->
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom='0px' :searchList='searchList' :rightEventList="rightEventList"
        @rightFunc='rightFunc' v-on:getSearchObj='getSearchObj'>
      </publicExpandSearch>
    </div>
    <el-main class="section">
      <!-- 食物类型 -->
      <FoodTypeView ref="foodTypeRef" :foodTreeData="treeData" @payloadId="payloadDetailsHandel" class="chat-list">
      </FoodTypeView>

      <!-- 食物明细 -->
      <div class="chat-content">
        <h1>食物明细</h1>
        <div class="base-table-view">
          <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
            <BaseTable :data="tableData" :column="foodTable" pagination :auto-scroll="true" :total="totalPage"
              :page.sync="searchParams.current" :limit.sync="searchParams.size" @pagination="getPaginationList">
            </BaseTable>
          </el-scrollbar>
        </div>

      </div>
      <!-- 新增食物或者修改 -->
      <FoodAddOrEdit ref="foodAddRef" class="food-add-edit" :isFoodType.sync="foodType" :foodTreeData="treeData"
        :showParamsData="foodShowParamsData" @submitSuccess="submitSuccessHandel">
      </FoodAddOrEdit>
    </el-main>
  </el-container>
</template>

<script>
import Case7Header from "../../components/Case7Header";
import FoodTypeView from "../../components/FoodTypeView";
import FoodAddOrEdit from "../../components/FoodAddOrEdit";
import foodTab from "../../common/foodTab.config";
import {
  apiGetFoodTree,
  apiPostFoodPage,
  apiPostAddFood,
  apiDeleteFood,
  apiUpdateStatusFood,
  apiGetFood
} from "../../api";
export default {
  name: "Case7",
  mixins: [foodTab],
  data() {
    return {
      breadList: [{ name: "标准数据库" }, { name: "食物类型管理" }],
      searchList: [
        {
          label: "食物类型项目",
          paramName: "redundant",
          inputType: "input",
          width: "280px",
          clearVal:false,
          date:''
        }
      ],
      searchParams: {
        current: 1,
        size: 10
      },
      rightEventList: [],
      tableData: [],
      treeData: [], //树形数据
      foodShowParamsData: {},
      redundant: "", //文字搜索
      totalPage: 0,
      foodType: true, //true 为新增 false为修改
    //   listQuery: {
    //     size: 10,
    //     current: 1
    //   }
    };
  },
  components: {
    Case7Header,
    FoodTypeView,
    FoodAddOrEdit
  },
  created() {
    this.init();
  },
  watch: {
    foodType: {
      handler(newVal, oldVal) {
        if (newVal == true) {
          this.tableData = this.tableData.map(item => {
            item.disabled = false;
            return item;
          });
        }
      }
    }
  },
  methods: {
    /**
     * @description: 编辑 点击编辑启用删除按钮为禁用状态,滚动条初始化
     * @param {*}
     * @return {*}
     */

    editTableItemHandel(scope) {
      apiGetFood(scope.row.id).then(res => {
        if (res.code == 0) {
          this.foodType = false;
          this.$refs.foodAddRef.scrollHandel();
          const scopeItem = scope.row;
          this.tableData = this.tableData.map(item => {
            item.disabled = false;
            return item;
          });
          scopeItem.disabled = true;
          this.tableData.splice(scope.$index, 1, scopeItem);
          this.foodShowParamsData = res.data || {};
        }
      });
    },

    /**
     * @description: 停用，启用
     * @param {*}
     * @return {*}
     */

    updateStatusFood(scope) {
      apiUpdateStatusFood(scope.row.id).then(res => {
        if (res.code == 0) {
          let scopeItem = scope.row;
          scopeItem.status = scopeItem.status == 1 ? 0 : 1;
          this.tableData.splice(scope.$index, 1, scopeItem);
          this.$message({
            type: "success",
            message: "成功!"
          });
        } else {
          this.$message({
            type: "error",
            message: res.message
          });
        }
      });
    },

    /**
     * @description: 删除
     * @param {*}
     * @return {*}
     */

    removeHandel(scope) {
      this.$confirm("确定要删除当前食物相关信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "message-confirm-style"
      }).then(() => {
        apiDeleteFood(scope.row.id).then(res => {
          if (res.code == 0) {
            // this.tableData.splice(scope.$index,1);
            this.payloadDetailsHandel(this.foodSmallId);
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      });
    },

    /**
     * @description: callback 列表
     * @param {*}
     * @return {*}
     */

    submitSuccessHandel() {
      this.payloadDetailsHandel(this.foodSmallId);
      this.foodType = true;
    },

    /**
     * @description: 查询
     * @param {*}
     * @return {*}
     */

    inquireHandel(options) {
      this.$refs.foodTypeRef.$refs.treeRef.$children.forEach(
        item => (item.expanded = false)
      );
      this.redundant = options.redundant;
      apiPostFoodPage({
        current: 1,
        size: 10,
        redundant: options.redundant
      }).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.totalPage = res.data.total;
        }
      });
    },

    /**分页
     * @description:
     * @param {*}
     * @return {*}
     */

    getPaginationList() {
      apiPostFoodPage({
        ...this.searchParams, 
        foodSmallId: this.foodSmallId
      }).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.totalPage = res.data.total;
        }
      });
    },

    /**
     * @description: 标准数据库食材库树结构
     * @param {*}
     * @return {*}
     */

    init() {
      apiGetFoodTree().then(res => {
        if (res.code == 0) {
          this.treeData = res.data;
        }
      });
    },

    /**
     * @description: 点击单条数据调取接口
     * @param {*}
     * @return {*}
     */

    payloadDetailsHandel(optios,flag) {  
      if(flag){
        this.searchList[0].clearVal = true
        this.searchList[0].date = new Date().getTime()
        this.searchParams.redundant = ''
      } 
      this.searchParams.current = 1
      this.foodSmallId = optios;
      apiPostFoodPage({ 
        foodSmallId: optios, 
        ...this.searchParams
      }).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.totalPage = res.data.total;
        }
      });
    },
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.payloadDetailsHandel();
    },
    rightFunc(item) {
      
    }
  }
};
</script>

<style scoped lang="less">
@import "./index.less";
</style>
